import React from 'react';
import classes from './RecordVideo.module.css';

const TenMinutesLeft = ({ time }) => {
  return time >= 290 && time < 300 ? (
    <div className={classes.countdownCircle}>
      <div>{300 - time}</div>
    </div>
  ) : null;
};

export default TenMinutesLeft;
